import React from 'react';
import {withFormsy} from "formsy-react";
import Editor from "../../../js/plugins/lexical/Editor";

const TextEditorInput = ({setValue, getValue, value, error, placeholder, disabled, name, ...props}) => {
    const errorMessage = props.getErrorMessage();

    let className = props.className || '';
    className += props.showRequired() ? ' required ' : '';

    className += !props.isValid() && props.isFormSubmitted() ? ' text-danger ' : '';

    let inputClassName = !props.isValid() && props.isFormSubmitted() ? ' is-invalid ' : '';

    return (
        <div className={'form-group txt-editor ' + className}>
            {props.label !== false && (
                <label className="col-form-label"
                       data-required={props.required}>
                    {props.label}
                    {props.required && <span className="required-symbol"> *</span>}
                </label>
            )}


            {/*<div className="editor-shell">*/}
            {/*    <ChatEditor*/}
            {/*        maxLength={props.maxLength}*/}
            {/*        isReadOnly={props.isReadOnly}*/}
            {/*        hideToolbar={props.isReadOnly}*/}
            {/*        enableScroll={props.enableScroll}*/}
            {/*        value={getValue() || ""}*/}
            {/*        placeholder={placeholder || "Enter some text.."}*/}
            {/*        disabled={disabled}*/}
            {/*        onChange={change => setValue(change)}/>*/}
            {/*</div>*/}

            <div className="relative">
                <Editor
                    tools={props.tools}
                    extra={props.extra}
                    maxLength={props.maxLength}
                    minLength={props.minLength}
                    isReadOnly={props.isReadOnly}
                    hideToolbar={props.isReadOnly}
                    enableScroll={props.enableScroll}
                    value={getValue() || ""}
                    placeholder={placeholder || "Enter some text.."}
                    disabled={disabled}
                    onChange={change => setValue(change)}
                />
            </div>
            {errorMessage && (
                <span className={'invalid-feedback'} style={{marginTop: '-1rem'}}>
                    {errorMessage}
                </span>
            )}
        </div>
    );
};

TextEditorInput.propTypes = {};

export default withFormsy(TextEditorInput);